import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.symbol)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: _ctx.symbol,
          placement: "top",
          ref: "tooltipRef",
          disabled: _ctx.isScrolling,
          "hide-after": 100,
          "show-after": 200
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.isPlaceholder)
                ? (_openBlock(), _createElementBlock("figure", {
                    key: 0,
                    onClick: [
                      _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('stock-click'))),
                      _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args)), ["stop"]))
                    ],
                    class: _normalizeClass(["stock_logo placeholder", [
            _ctx.MarketClass,
            {
              placeholderWithContent: _ctx.placeholderContent,
              postTicker: _ctx.isPostTicker,
            },
          ]]),
                    onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args))),
                    style: _normalizeStyle({
            ..._ctx.style,
            width: _ctx.size?.width,
            height: _ctx.size?.height,
            flex: `0 0 ${_ctx.size?.width}`,
          })
                  }, [
                    (_ctx.placeholderContent)
                      ? (_openBlock(), _createElementBlock("figcaption", _hoisted_1, _toDisplayString(`${_ctx.placeholderContent}+`), 1))
                      : _createCommentVNode("", true)
                  ], 38))
                : (_openBlock(), _createElementBlock("figure", {
                    key: 1,
                    onClick: [
                      _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('stock-click'))),
                      _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args)), ["stop"]))
                    ],
                    class: _normalizeClass(["stock_logo", [_ctx.MarketClass, { postTicker: _ctx.isPostTicker }]]),
                    onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args))),
                    style: _normalizeStyle({
            ..._ctx.style,
            width: _ctx.size?.width,
            height: _ctx.size?.height,
            flex: `0 0 ${_ctx.size?.width}`,
          })
                  }, [
                    (_ctx.currentImageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.currentImageUrl,
                          onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                          style: _normalizeStyle({
            width: _ctx.size?.width,
            height: _ctx.size?.height,
            flex: `0 0 ${_ctx.size?.width}`,
          })
                        }, null, 44, _hoisted_2))
                      : _createCommentVNode("", true)
                  ], 38))
            ])
          ]),
          _: 1
        }, 8, ["content", "disabled"]))
      : _createCommentVNode("", true),
    (!_ctx.symbol)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.isPlaceholder)
            ? (_openBlock(), _createElementBlock("figure", {
                key: 0,
                class: _normalizeClass(["stock_logo placeholder", { placeholderWithContent: _ctx.placeholderContent }]),
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args)), ["stop"])),
                onTouchstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args))),
                style: _normalizeStyle({
          ..._ctx.style,
          width: _ctx.size?.width,
          height: _ctx.size?.height,
          flex: `0 0 ${_ctx.size?.width}`,
        })
              }, [
                (_ctx.placeholderContent)
                  ? (_openBlock(), _createElementBlock("figcaption", _hoisted_3, _toDisplayString(`${_ctx.placeholderContent}+`), 1))
                  : _createCommentVNode("", true)
              ], 38))
            : (_openBlock(), _createElementBlock("figure", {
                key: 1,
                class: _normalizeClass(["stock_logo", _ctx.market]),
                onTouchstart: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args))),
                onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToStockDetail && _ctx.goToStockDetail(...args)), ["stop"])),
                style: _normalizeStyle({
          ..._ctx.style,
          width: _ctx.size?.width,
          height: _ctx.size?.height,
          flex: `0 0 ${_ctx.size?.width}`,
        })
              }, [
                (_ctx.currentImageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.currentImageUrl,
                      onError: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                      style: _normalizeStyle({
          width: _ctx.size?.width,
          height: _ctx.size?.height,
          flex: `0 0 ${_ctx.size?.width}`,
        })
                    }, null, 44, _hoisted_4))
                  : _createCommentVNode("", true)
              ], 38))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}